module.exports = __webpack_public_path__ + "img/dollar-icon.22dd2998.svg";